<template>
    <div id="dashboard2">
        <div v-if="seePMDashboard">
            <!-- charts filters  -->
            <div class="fix-filters space-btw-charts">
                <vx-card>
                    <vs-row>
                        <!-- From Date  -->
                        <vs-col vs-xs="6" vs-sm="5" vs-lg="3">
                            <SelectDate :selectedDate.sync="filters.from_date" label="Start Date" />
                            <small class="block text-danger mt-1" v-if="api_errors && api_errors.from_date">
                                {{ api_errors.from_date.join(', ') }}
                            </small>
                        </vs-col>
                        <!-- To Date  -->
                        <vs-col vs-xs="6" vs-sm="5" vs-lg="3" class="mobile_to_date">
                            <div class="ml-2">
                                <SelectDate :selectedDate.sync="filters.to_date" label="End Date" />
                            </div>
                            <small class="block text-danger mt-1" v-if="api_errors && api_errors.to_date">
                                {{ api_errors.to_date.join(', ') }}
                            </small>
                        </vs-col>
                    </vs-row>
                </vx-card>
            </div>
            <!-- mobile screen -->
            <div v-if="$store.state.windowWidth <= 767">
                <!-- box count -->
                <vs-row class="space-btw-charts">
                    <vs-col vs-xs="4" vs-sm="4">
                        <div class="mobile-box-count mb-2 mr-2">
                            <vx-card>
                                <div>
                                    <h6>{{ box_data.total_accident_free_hrs }}</h6>
                                    <span>Total Accident Free Hrs</span>
                                </div>
                            </vx-card>
                        </div>
                    </vs-col>
                    <vs-col vs-xs="4" vs-sm="4">
                        <div class="mobile-box-count mb-2 mr-2">
                            <vx-card>
                                <div>
                                    <h6>{{ box_data.total_mm_carried_out }}</h6>
                                    <span>Major Maintenance Carried Out</span>
                                </div>
                            </vx-card>
                        </div>
                    </vs-col>
                    <vs-col vs-xs="4" vs-sm="4">
                        <div class="mobile-box-count mb-2">
                            <vx-card>
                                <div>
                                    <h6>{{ box_data.active_enroachment_count }}</h6>
                                    <span>Active Enroachment Issue</span>
                                </div>
                            </vx-card>
                        </div>
                    </vs-col>
                    <vs-col vs-xs="4" vs-sm="4">
                        <div class="mobile-box-count mr-2">
                            <vx-card>
                                <div>
                                    <h6>{{ box_data.safety_program_conducted }}</h6>
                                    <span>Total Safety Program Conducted</span>
                                </div>
                            </vx-card>
                        </div>
                    </vs-col>
                    <vs-col vs-xs="4" vs-sm="4">
                        <div class="mobile-box-count">
                            <vx-card>
                                <div>
                                    <h6>{{ (box_data.spent_on_maintenance/100000).toFixed(1) }}</h6>
                                    <span>Spent on Maintenance (Lakhs)</span>
                                </div>
                            </vx-card>
                        </div>
                    </vs-col>
                </vs-row>
                <!-- pie chart start  -->
                <vs-row class="space-btw-charts">
                    <vs-col vs-xs="12" vs-sm="12" vs-lg="12">
                        <vx-card class="widget pb-3">
                            <template slot="no-body">
                                <div class="widget--heading" style="display: flex; flex-direction: column;">
                                    <div class="mb-2" style="align-self: start;">
                                        <h5>Maintenance Type</h5>
                                    </div>
                                    <div style="width: 100%;">
                                        <vs-row class="mb-2">
                                            <vs-col vs-xs="10">
                                                <InputSelect :model.sync="pie_maintenance_sub_type"
                                                    placeholder="Choose" container_class="w-auto d2-other-pie-dropdown-alignment input-custom-dropdown"
                                                    :options="pie_maintenance_sub_type_options" :multiple="false" 
                                                />
                                            </vs-col>
                                        </vs-row>
                                    </div>
                                </div>
                            </template>
                            <div>
                                <PieChart :labels="maintenance_type_pie_labels" :dataset="maintenance_type_pie_data"
                                    :height="280" :labels_background_color="pie_background_labels_five_status" legend_position="bottom"
                                    legend_font_size="8"
                                />
                            </div>
                        </vx-card>
                    </vs-col>
                </vs-row>
                <vs-row class="space-btw-charts">
                    <vs-col vs-xs="12" vs-sm="12" vs-lg="12">
                        <vx-card class="widget pb-3">
                            <template slot="no-body">
                                <div class="widget--heading" style="display: flex; flex-direction: column;">
                                    <div class="mb-2" style="align-self: start;">
                                        <h5>Road Incidents</h5>
                                    </div>
                                    <div style="width: 100%;">
                                        <vs-row class="mb-2">
                                            <vs-col vs-xs="10">
                                                <InputSelect :model.sync="pie_road_incident_sub_type" placeholder="Choose"
                                                    container_class="w-auto d2-other-pie-dropdown-alignment input-custom-dropdown"
                                                    :options="pie_road_incident_sub_type_options" :multiple="false" 
                                                />
                                            </vs-col>
                                        </vs-row>
                                    </div>
                                </div>
                            </template>
                            <div>
                                <PieChart :labels="road_incident_pie_labels" :dataset="road_incident_pie_data"
                                    :height="280" :labels_background_color="pie_background_labels_five_status" legend_position="bottom"
                                    legend_font_size="8"
                                />
                            </div>
                        </vx-card>
                    </vs-col>
                </vs-row>
                <vs-row class="space-btw-charts">
                    <vs-col vs-xs="12" vs-sm="12" vs-lg="12">
                        <vx-card class="widget pb-3">
                            <template slot="no-body">
                                <div class="widget--heading" style="display: flex; flex-direction: column;">
                                    <div class="mb-2" style="align-self: start;">
                                        <h5>Enroachment/Safety</h5>
                                    </div>
                                    <div style="width: 100%;">
                                        <vs-row class="mb-2">
                                            <vs-col vs-xs="10">
                                                <InputSelect :model.sync="pie_enroachment_safety_sub_type"
                                                    placeholder="Choose" container_class="w-auto d2-other-pie-dropdown-alignment input-custom-dropdown"
                                                    :options="pie_enroachment_safety_sub_type_options" :multiple="false" 
                                                />
                                            </vs-col>
                                        </vs-row>
                                    </div>
                                </div>
                            </template>
                            <div>
                                <PieChart :labels="enroachment_safety_pie_labels" :dataset="enroachment_safety_pie_data"
                                    :height="280" :labels_background_color="pie_background_labels_five_status" legend_position="bottom"
                                    legend_font_size="8"
                                />
                            </div>
                        </vx-card>
                    </vs-col>
                </vs-row>
                <!-- pie chart end  -->
                <!-- bar chart  -->
                <vs-row class="space-btw-charts">
                    <vs-col vs-xs="12" vs-sm="12" vs-lg="12">
                        <vx-card class="widget pb-3">
                            <template slot="no-body">
                                <div class="widget--heading" style="display: flex; flex-direction: column;">
                                    <div class="mb-2" style="align-self: start;">
                                        <h5>Bar Chart</h5>
                                    </div>
                                    <div style="width: 100%;">
                                        <vs-row class="mb-2">
                                            <vs-col vs-xs="5" vs-sm="5">
                                                <h6>MM Sub Module</h6>
                                            </vs-col>
                                            <vs-col vs-xs="7" vs-sm="7">
                                                <InputSelect :model.sync="bar_major_maintenance_sub_type"
                                                    placeholder="Choose"
                                                    container_class="w-auto d2-dropdown-alignment input-custom-dropdown mr-3"
                                                    :options="major_maintenance_sub_type_options" :multiple="false" 
                                                    :disabled="bar_road_incident_sub_type!==null"
                                                />
                                            </vs-col>
                                        </vs-row>
                                        <vs-row>
                                            <vs-col vs-xs="5" vs-sm="5">
                                                <h6>RI Sub Module</h6>
                                            </vs-col>
                                            <vs-col vs-xs="7" vs-sm="7">
                                                <InputSelect :model.sync="bar_road_incident_sub_type"
                                                    placeholder="Choose"
                                                    container_class="w-auto d2-dropdown-alignment input-custom-dropdown mr-3"
                                                    :options="road_incident_sub_type_options" :multiple="false"
                                                    :disabled="bar_major_maintenance_sub_type!==null"
                                                />
                                            </vs-col>
                                        </vs-row>
                                    </div>
                                </div>
                            </template>
                            <BarChart legend_position="bottom" x_axis_title="Month/Year" y_axis_title="No. of Issues"
                                :labels_mode_background_color="bar_labels_mode_background_color"
                                :labels_mode="bar_labels_mode" :labels="bar_labels" :dataset="bar_data" :stacked="true"
                                :height="320" legend_font_size="8" />
                        </vx-card>
                    </vs-col>
                </vs-row>
                <!-- line chart  -->
                <vs-row class="space-btw-charts">
                    <vs-col vs-xs="12" vs-sm="12" vs-lg="12">
                        <vx-card class="widget">
                            <template slot="no-body">
                                <div class="widget--heading" style="display: flex; flex-direction: column;">
                                    <div class="mb-2" style="align-self: start;">
                                        <h5>Line Chart</h5>
                                    </div>
                                    <div style="width: 100%;">
                                        <vs-row class="mb-2">
                                            <vs-col vs-xs="5" vs-sm="5">
                                                <h6>Module Type</h6>
                                            </vs-col>
                                            <vs-col vs-xs="7" vs-sm="7">
                                                <InputSelect :model.sync="line_filters.line_module_type" placeholder="Choose"
                                                    container_class="w-auto d2-dropdown-alignment input-custom-dropdown mr-3" 
                                                    :options="module_type_options" :multiple="false" 
                                                />
                                            </vs-col>
                                        </vs-row>
                                        <template v-if="line_filters.line_module_type == 'road_incident'">
                                            <vs-row :key="line_filters.line_module_type + 'ri'">
                                                <vs-col vs-xs="5" vs-sm="5">
                                                    <h6>RI Sub Module</h6>
                                                </vs-col>
                                                <vs-col vs-xs="7" vs-sm="7">
                                                    <InputSelect :model.sync="line_filters.line_road_incident_sub_type"
                                                        placeholder="Choose" container_class="w-auto d2-dropdown-alignment input-custom-dropdown mr-3"
                                                        :options="road_incident_sub_type_options" :multiple="false" 
                                                    />
                                                </vs-col>
                                            </vs-row>
                                        </template>
                                        <template v-else-if="line_filters.line_module_type == 'major_maintenance'">
                                            <vs-row :key="line_filters.line_module_type + 'mm'">
                                                <vs-col vs-xs="5" vs-sm="5">
                                                    <h6>MM Sub Module</h6>
                                                </vs-col>
                                                <vs-col vs-xs="7" vs-sm="7">
                                                    <InputSelect :model.sync="line_filters.line_major_maintenance_sub_type"
                                                        placeholder="Choose" container_class="w-auto d2-dropdown-alignment input-custom-dropdown mr-3"
                                                        :options="major_maintenance_sub_type_options" :multiple="false"
                                                    />
                                                </vs-col>
                                            </vs-row>
                                        </template>
                                    </div>
                                </div>
                            </template>
                            <LineChart :labels="line_labels" :dataset="line_data" legend_position="bottom" :height="350"
                                :background_color="line_chart_background_color" />
                        </vx-card>
                    </vs-col>
                </vs-row>
            </div>
            <div v-else>
                <div style="width: 100%;">
                    <!-- box count -->
                    <vs-row class="space-btw-charts">
                        <vs-col vs-xs="12" vs-sm="12" vs-lg="12">
                            <div class="flex">
                                <div class="box-data-card">
                                    <vx-card>
                                        <div class="box-data-alignment-d1">
                                            <span class="box-icon"><font-awesome-icon :icon="carCrash" /></span>
                                            <div class="box-count">
                                                <span>Total Accident Free Hrs</span>
                                                <h6 style="display: flex; justify-content: center;">{{
                                                    box_data.total_accident_free_hrs }}</h6>
                                            </div>
                                        </div>
                                    </vx-card>
                                </div>
                                <div class="ml-2 box-data-card">
                                    <vx-card>
                                        <div class="box-data-alignment-d1">
                                            <span class="box-icon"><font-awesome-icon :icon="clipboardCheck" /></span>
                                            <div class="box-count">
                                                <span>Major Maintenance Carried Out</span>
                                                <h6 style="display: flex; justify-content: center;">{{
                                                    box_data.total_mm_carried_out }}</h6>
                                            </div>
                                        </div>
                                    </vx-card>
                                </div>
                                <div class="ml-2 box-data-card">
                                    <vx-card>
                                        <div class="box-data-alignment-d1">
                                            <span class="box-icon"><font-awesome-icon :icon="clipboardList" /></span>
                                            <div class="box-count">
                                                <span>Active Enroachment Issue</span>
                                                <h6 style="display: flex; justify-content: center;">{{
                                                    box_data.active_enroachment_count }}</h6>
                                            </div>
                                        </div>
                                    </vx-card>
                                </div>
                                <div class="ml-2 box-data-card">
                                    <vx-card>
                                        <div class="box-data-alignment-d1">
                                            <span class="box-icon"><font-awesome-icon :icon="shield" /></span>
                                            <div class="box-count">
                                                <span>Total Safety Program Conducted</span>
                                                <h6 style="display: flex; justify-content: center;">{{
                                                    box_data.safety_program_conducted }}</h6>
                                            </div>
                                        </div>
                                    </vx-card>
                                </div>
                                <div class="ml-2 box-data-card">
                                    <vx-card>
                                        <div class="box-data-alignment-d1">
                                            <span class="box-icon"><font-awesome-icon :icon="wallet" /></span>
                                            <div class="box-count">
                                                <span>Spent on Maintenance (Lakhs)</span>
                                                <h6 style="display: flex; justify-content: center;">{{
                                                    (box_data.spent_on_maintenance/100000).toFixed(1) }}</h6>
                                            </div>
                                        </div>
                                    </vx-card>
                                </div>
                            </div>
                        </vs-col>
                    </vs-row>
                    <!-- pie chart  -->
                    <vs-row class="space-btw-charts">
                        <vs-col vs-xs="12" vs-sm="12" vs-lg="12" class="">
                            <vx-card class="widget">
                                <template slot="no-body">
                                    <div class="widget--heading" style="justify-content: space-between;">
                                        <div class="mr-base" style="display:flex; align-items: center;">
                                            <h5 class="mr-3">Maintenance Type</h5>
                                            <div class="right">
                                                <InputSelect :model.sync="pie_maintenance_sub_type"
                                                    placeholder="Select Chart" container_class="w-auto d2-other-pie-dropdown-alignment input-custom-dropdown"
                                                    :options="pie_maintenance_sub_type_options" :multiple="false" />
                                            </div>
                                        </div>
                                        <div class="mr-base" style="display:flex; align-items: center;">
                                            <h5 class="mr-3">Road Incidents</h5>
                                            <div class="right">
                                                <InputSelect :model.sync="pie_road_incident_sub_type" placeholder="Select Chart"
                                                    container_class="w-auto d2-other-pie-dropdown-alignment input-custom-dropdown"
                                                    :options="pie_road_incident_sub_type_options" :multiple="false" />
                                            </div>
                                        </div>
                                        <div class="mr-base" style="display:flex; align-items: center;">
                                            <h5 class="mr-3">Enroachment/Safety</h5>
                                            <div class="right">
                                                <InputSelect :model.sync="pie_enroachment_safety_sub_type"
                                                    placeholder="Select Chart" container_class="w-auto d2-other-pie-dropdown-alignment input-custom-dropdown"
                                                    :options="pie_enroachment_safety_sub_type_options" :multiple="false" />
                                            </div>
                                        </div>
                                    </div>
                                </template>
                                <div>
                                    <div style="display: flex; justify-content: space-between;">
                                        <PieChart :labels="maintenance_type_pie_labels" :dataset="maintenance_type_pie_data"
                                            :height="280" :labels_background_color="pie_background_labels_five_status" />
    
                                        <div class="vertical"></div>
    
                                        <!-- road incident  -->
                                        <PieChart :labels="road_incident_pie_labels" :dataset="road_incident_pie_data"
                                            :height="280" :labels_background_color="pie_background_labels_five_status" />
    
                                        <div class="vertical"></div>
    
                                        <!-- enroachment/safety  -->
                                        <PieChart :labels="enroachment_safety_pie_labels" :dataset="enroachment_safety_pie_data"
                                            :height="280" :labels_background_color="pie_background_labels_five_status" />
                                    </div>
                                    <div class="mt-base mb-3 d2-pie-legend">
                                        <div class="d2-pie-legend--container">
                                            <div style="background-color: #F76801;"></div>
                                            <p class="font-bold">Awaiting Approval</p>
                                        </div>
                                        <div class="d2-pie-legend--container">
                                            <div style="background-color: #4FA0FF;"></div>
                                            <p class="font-bold">Approval Rejected</p>
                                        </div>
                                        <div class="d2-pie-legend--container">
                                            <div style="background-color: #FFC276;"></div>
                                            <p class="font-bold">Resolution Pending</p>
                                        </div>
                                        <div class="d2-pie-legend--container">
                                            <div style="background-color: #E49A2C;"></div>
                                            <p class="font-bold">Resolution Rejected</p>
                                        </div>
                                        <div class="d2-pie-legend--container">
                                            <div style="background-color: #C1CD39;"></div>
                                            <p class="font-bold">Resolution Completed</p>
                                        </div>
                                    </div>
                                </div>
                            </vx-card>
                        </vs-col>
                    </vs-row>
                    <!-- bar chart  -->
                    <vs-row class="space-btw-charts">
                        <vs-col vs-xs="12" vs-sm="12" vs-lg="12">
                            <vx-card class="widget pb-3">
                                <template slot="no-body">
                                    <div class="widget--heading">
                                        <h5>Bar Chart</h5>
                                        <div class="flex right">
                                            <InputSelect :model.sync="bar_major_maintenance_sub_type"
                                                label="Major Maintenance Sub Module" placeholder="Select Chart"
                                                container_class="w-auto d2-dropdown-alignment input-custom-dropdown mr-base"
                                                :options="major_maintenance_sub_type_options" :multiple="false" 
                                                :disabled="bar_road_incident_sub_type!==null"
                                            />
                                            <InputSelect :model.sync="bar_road_incident_sub_type"
                                                label="Road Incident Sub Module" placeholder="Select Chart"
                                                container_class="w-auto d2-dropdown-alignment input-custom-dropdown"
                                                :options="road_incident_sub_type_options" :multiple="false"
                                                :disabled="bar_major_maintenance_sub_type!==null"
                                            />
                                        </div>
                                    </div>
                                </template>
                                <BarChart legend_position="bottom" x_axis_title="Month/Year" y_axis_title="No. of Issues"
                                    :labels_mode_background_color="bar_labels_mode_background_color"
                                    :labels_mode="bar_labels_mode" :labels="bar_labels" :dataset="bar_data" :stacked="true"
                                    :height="320" />
                            </vx-card>
                        </vs-col>
                    </vs-row>
                    <!-- line chart  -->
                    <vs-row class="space-btw-charts">
                        <vs-col vs-xs="12" vs-sm="12" vs-lg="12">
                            <vx-card class="widget">
                                <template slot="no-body">
                                    <div class="widget--heading">
                                        <h5>Line Chart</h5>
                                        <div class="flex right">
                                            <div style="min-width: 210px">
                                                <InputSelect :model.sync="line_filters.line_module_type" label="Module Type" placeholder="Choose"
                                                    container_class="w-auto input-custom-dropdown mr-3" :options="module_type_options" :multiple="false" 
                                                />
                                            </div>
                                            <template v-if="line_filters.line_module_type == 'road_incident'">
                                                <div :key="line_filters.line_module_type + 'ri'">
                                                    <InputSelect :model.sync="line_filters.line_road_incident_sub_type" label="Road Incident Sub Type"
                                                        placeholder="Choose" container_class="w-auto input-custom-dropdown"
                                                        :options="road_incident_sub_type_options" :multiple="false" 
                                                    />
                                                </div>
                                            </template>    
                                            <template v-else-if="line_filters.line_module_type == 'major_maintenance'">
                                                <div :key="line_filters.line_module_type + 'mm'">
                                                    <InputSelect :model.sync="line_filters.line_major_maintenance_sub_type" label="Major Maintenance Sub Type"
                                                        placeholder="Choose" container_class="w-auto input-custom-dropdown"
                                                        :options="major_maintenance_sub_type_options" :multiple="false"
                                                    />
                                                </div>
                                            </template>
                                        </div>
                                    </div>
                                </template>
                                <LineChart :labels="line_labels" :dataset="line_data" legend_position="bottom" :height="350"
                                    :background_color="line_chart_background_color" />
                            </vx-card>
                        </vs-col>
                    </vs-row>
                </div>
            </div>
        </div>
        <div v-else>
            <PermissionDenied />
        </div>
    </div>
</template>
  
<script>
import { faCarCrash, faClipboardList, faWallet, faClipboardCheck, faUserShield } from '@fortawesome/free-solid-svg-icons';
import SelectDate from '../components/letstream/ls-select-date/SelectDate.vue'
import moment from 'moment'
import { Request } from '../utils/requests'
import BarChart from '../views/charts/BarChart.vue'
import PieChart from './charts/PieChart.vue'
import MapChart from './charts/MapChart.vue'
import MapPopup from './charts/MapPopup.vue'
import LineChart from './charts/LineChart.vue'

export default {
    components: {
        BarChart,
        PieChart,
        SelectDate,
        MapChart,
        MapPopup,
        LineChart
    },
    data() {
        let now = new Date();
        let current_year = now.getFullYear();

        return {

            // pie
            pie_maintenance_sub_type_options: [
                { value: 'major_maintenance', label: 'Major Maintenance' },
                { value: 'routine_maintenance', label: 'Routine Maintenance' },
                { value: 'electrical_maintenance', label: 'Electrical Maintenance' },
                { value: 'highway', label: 'Corrective Maintenance' },
            ],

            pie_road_incident_sub_type_options: [
                { value: 'road_user_accident', label: 'Road User Accident' },
                { value: 'occupational', label: 'Occupational' },
                { value: 'hazard', label: 'Hazard' },
                { value: 'dead_animal_debris_removal', label: 'Dead Animal Debris Removal' },
                { value: 'vehicle_breakdown', label: 'Vehicle Breakdown' },
                { value: 'traffic_violation', label: 'Traffic Violation' },
                { value: 'unauthorised_parking', label: 'Unauthorised Parking' },
                { value: 'unauthorised_access', label: 'Unauthorised Access' },
                { value: 'unauthorised_media_cut', label: 'Unauthorised Median Cut' },
                { value: 'material_damage', label: 'Material Damage' },
                { value: 'other', label: 'Other' },
            ],

            pie_enroachment_safety_sub_type_options: [
                { value: 'enroachment_row', label: 'Enroachment Row' },
                { value: 'safety_program', label: 'Safety Program' },
            ],

            module_type_options: [
                { value: 'routine_maintenance', label: 'Routine Maintenance' },
                { value: 'electrical_maintenance', label: 'Electrical Maintenance' },
                { value: 'major_maintenance', label: 'Major Maintenance' },
                { value: 'highway', label: 'Corrective Maintenance' },
                { value: 'road_incident', label: 'Road Incident' },
                { value: 'enroachment_row', label: 'Enroachment Row' },
                { value: 'safety_program', label: 'Safety Program' },
            ],

            major_maintenance_sub_type_options: [
                { value: 'main_issue', label: 'Main Issue' },
                { value: 'mm_bituminous_concrete_overlay', label: 'Bituminous Concrete Overlay' },
                { value: 'mm_dense_bituminous_concrete_overlay', label: 'Dense Bituminous Concrete Overlay' },
                { value: 'mm_milling', label: 'Milling' },
                { value: 'mm_thermoplastic_road_marking', label: 'Thermoplastic RoadMarking' },
                { value: 'mm_shoulder_raising', label: 'Shoulder Raising' },
                { value: 'mm_road_sruds_fixing', label: 'RoadSruds Fixing' },
                { value: 'mm_kerb_topping', label: 'Kerb Topping' },
                { value: 'mm_kerb_painting', label: 'Kerb Painting/Crash Barrier' },
                { value: 'mm_microsurfacing', label: 'Micro Surfacing' },
                { value: 'mm_tack_coat', label: 'Tack Coat' },
            ],

            road_incident_sub_type_options: [
                { value: 'road_user_accident', label: 'Road User Accident' },
                { value: 'occupational', label: 'Occupational' },
                { value: 'hazard', label: 'Hazard' },
                { value: 'dead_animal_debris_removal', label: 'Dead Animal Debris Removal' },
                { value: 'vehicle_breakdown', label: 'Vehicle Breakdown' },
                { value: 'traffic_violation', label: 'Traffic Violation' },
                { value: 'unauthorised_parking', label: 'Unauthorised Parking' },
                { value: 'unauthorised_access', label: 'Unauthorised Access' },
                { value: 'unauthorised_media_cut', label: 'Unauthorised Median Cut' },
                { value: 'material_damage', label: 'Material Damage' },
                { value: 'other', label: 'Other' },
            ],

            api_errors: {},

            filters: {
                from_date: moment(new Date(`${current_year}-01-01`)).format('YYYY-MM-DD'),
                to_date: moment(now).format('YYYY-MM-DD'),
            },

            // pie filter 
            pie_maintenance_sub_type: null,
            pie_road_incident_sub_type: null,
            pie_enroachment_safety_sub_type: null,

            // bar filter
            bar_major_maintenance_sub_type: null,
            bar_road_incident_sub_type: null,

            // box count data
            box_data: {},

            // pie count data
            pie_background_labels_five_status: ['#F76801', '#4FA0FF', '#FFC276', '#E49A2C', '#C1CD39'],

            maintenance_type_pie_labels: [],
            maintenance_type_pie_data: [],

            road_incident_pie_labels: [],
            road_incident_pie_data: [],

            enroachment_safety_pie_labels: [],
            enroachment_safety_pie_data: [],

            //bar data
            bar_data: {},
            bar_labels: [],
            bar_labels_mode: {},
            bar_labels_mode_background_color: {
                'routine_maintenance': '#FFAF00',
                'electrical_maintenance': '#FED600',
                'major_maintenance': '#FFA775',
                'corrective_maintenance': '#E4640A',
                'road_incident': '#C27E18',
                'enroachment_row': '#B70606',
                'safety_program': '#BE9700',
            },

            // line data
            line_chart_background_color: {},
            line_labels: [],
            line_data: {},
            line_filters: {
                line_module_type: null,
                line_major_maintenance_sub_type: null,
                line_road_incident_sub_type: null,
            },

        }
    },
    watch: {
        filters: {
            deep: true,
            handler(newV) {
                this.load_data();
            }
        },
        pie_maintenance_sub_type(newV, oldV) {
            if (newV == oldV) return

            if (!this.validating_filters()) {
                this.load_maintenance_type_pie_data()
            }
        },
        pie_road_incident_sub_type(newV, oldV) {
            if (newV == oldV) return

            if (!this.validating_filters()) {
                this.load_road_incident_pie_data()
            }
        },
        pie_enroachment_safety_sub_type(newV, oldV) {
            if (newV == oldV) return

            if (!this.validating_filters()) {
                this.load_enroachment_safety_pie_data()
            }
        },
        bar_major_maintenance_sub_type(newV, oldV) {
            if (newV == oldV) return

            if (!this.validating_filters()) {
                this.load_bar_data()
            }
        },
        bar_road_incident_sub_type(newV, oldV) {
            if (newV == oldV) return

            if (!this.validating_filters()) {
                this.load_bar_data()
            }
        },
        line_filters: {
            deep: true,
            handler() {
                this.load_line_data()
            }
        }
    },
    computed: {
        carCrash: () => faCarCrash,
        clipboardList: () => faClipboardList,
        shield: () => faUserShield,
        wallet: () => faWallet,
        clipboardCheck: () => faClipboardCheck,
        seePMDashboard() {
            return this.hasAccess('read', 'pm_dashboard', 'all')
        }
    },
    mounted() {
        if(window.innerWidth >= 1200) {
            this.$store.commit('UPDATE_SIDEBAR_ITEMS_MIN', true)
            this.$store.commit('TOGGLE_REDUCE_BUTTON', true)
            this.$store.dispatch('updateSidebarWidth', 'reduced')
        }
        if (this.$store.state.is_online && this.seePMDashboard) {
            this.load_data()
        }
    },
    beforeDestroy(){
        if(window.innerWidth >= 1200) {
            this.$store.commit('UPDATE_SIDEBAR_ITEMS_MIN', false)
            this.$store.commit('TOGGLE_REDUCE_BUTTON', false)
            this.$store.dispatch('updateSidebarWidth', 'default')
        }
    },
    methods: {
        validating_filters() {

            if (!this.filters.from_date) {
                this.api_errors = {
                    "from_date": [
                        "Date from is required.",
                    ]
                }
                return true
            }

            if (!this.filters.to_date) {
                this.api_errors = {
                    "to_date": [
                        "Date to is required.",
                    ]
                }
                return true
            }

            if (this.filters.from_date > this.filters.to_date) {
                this.api_errors = {
                    "from_date": [
                        "should be less than to date.",
                    ]
                }
                return true
            }

            return false
        },
        load_data() {
            if (!this.validating_filters()) {
                this.load_box_data()
                this.load_maintenance_type_pie_data()
                this.load_road_incident_pie_data()
                this.load_enroachment_safety_pie_data()
                this.load_bar_data()
                this.load_line_data()
            }
        },
        // box data
        load_box_data() {

            let url = this.$store.state.apiendpoints.dashboard_stats_view2

            let payload = {
                'metric_type': 'box_count',
            }

            payload['from_date'] = this.filters.from_date
            payload['to_date'] = this.filters.to_date

            Request(this, 'GET', url, payload).then(
                (res) => {
                    this.box_data = res.chart_data.box_count
                    this.api_errors = {}
                },
                (err) => {
                    if (err.error) {
                        this.api_errors = err.error
                        this.$vs.notify({
                            time: 2500,
                            title: 'Error',
                            text: (err.error && err.error.__non_field_errors__) ? err.error.__non_field_errors__.join(',') : 'An Error Occured. Please Try Again',
                            iconPack: 'feather',
                            icon: 'icon-alert-circle',
                            color: 'danger'
                        })
                    } else {
                        this.$vs.notify({
                            time: 2500,
                            title: 'Error',
                            text: "Server error occured while loading charts. Please try again later.",
                            iconPack: 'feather',
                            icon: 'icon-alert-circle',
                            color: 'danger'
                        })
                    }
                }
            )
        },
        //pie data
        load_maintenance_type_pie_data() {

            let url = this.$store.state.apiendpoints.dashboard_stats_view2

            let payload = {
                'metric_type': 'pie_count',
                'module_type': 'maintenance_type'
            }

            payload['from_date'] = this.filters.from_date
            payload['to_date'] = this.filters.to_date

            if (this.pie_maintenance_sub_type) {
                payload['pie_maintenance_sub_type'] = this.pie_maintenance_sub_type
            }

            Request(this, 'GET', url, payload).then(
                (res) => {
                    this.maintenance_type_pie_labels = res.chart_data.labels
                    this.maintenance_type_pie_data = res.chart_data.count
                    this.api_errors = {}
                },
                (err) => {
                    if (err.error) {
                        this.api_errors = err.error
                        this.$vs.notify({
                            time: 2500,
                            title: 'Error',
                            text: (err.error && err.error.__non_field_errors__) ? err.error.__non_field_errors__.join(',') : 'An Error Occured. Please Try Again',
                            iconPack: 'feather',
                            icon: 'icon-alert-circle',
                            color: 'danger'
                        })
                    } else {
                        this.$vs.notify({
                            time: 2500,
                            title: 'Error',
                            text: "Server error occured while loading charts. Please try again later.",
                            iconPack: 'feather',
                            icon: 'icon-alert-circle',
                            color: 'danger'
                        })
                    }
                }
            )
        },
        load_road_incident_pie_data() {

            let url = this.$store.state.apiendpoints.dashboard_stats_view2

            let payload = {
                'metric_type': 'pie_count',
                'module_type': 'road_incident'
            }

            payload['from_date'] = this.filters.from_date
            payload['to_date'] = this.filters.to_date

            if (this.pie_road_incident_sub_type) {
                payload['pie_road_incident_sub_type'] = this.pie_road_incident_sub_type
            }

            Request(this, 'GET', url, payload).then(
                (res) => {
                    this.road_incident_pie_labels = res.chart_data.labels
                    this.road_incident_pie_data = res.chart_data.count
                    this.api_errors = {}
                },
                (err) => {
                    if (err.error) {
                        this.api_errors = err.error
                        this.$vs.notify({
                            time: 2500,
                            title: 'Error',
                            text: (err.error && err.error.__non_field_errors__) ? err.error.__non_field_errors__.join(',') : 'An Error Occured. Please Try Again',
                            iconPack: 'feather',
                            icon: 'icon-alert-circle',
                            color: 'danger'
                        })
                    } else {
                        this.$vs.notify({
                            time: 2500,
                            title: 'Error',
                            text: "Server error occured while loading charts. Please try again later.",
                            iconPack: 'feather',
                            icon: 'icon-alert-circle',
                            color: 'danger'
                        })
                    }
                }
            )
        },
        load_enroachment_safety_pie_data() {

            let url = this.$store.state.apiendpoints.dashboard_stats_view2

            let payload = {
                'metric_type': 'pie_count',
                'module_type': 'enroachment_safety'
            }

            payload['from_date'] = this.filters.from_date
            payload['to_date'] = this.filters.to_date

            if (this.pie_enroachment_safety_sub_type) {
                payload['pie_enroachment_safety_sub_type'] = this.pie_enroachment_safety_sub_type
            }

            Request(this, 'GET', url, payload).then(
                (res) => {
                    this.enroachment_safety_pie_labels = res.chart_data.labels
                    this.enroachment_safety_pie_data = res.chart_data.count
                    this.api_errors = {}
                },
                (err) => {
                    if (err.error) {
                        this.api_errors = err.error
                        this.$vs.notify({
                            time: 2500,
                            title: 'Error',
                            text: (err.error && err.error.__non_field_errors__) ? err.error.__non_field_errors__.join(',') : 'An Error Occured. Please Try Again',
                            iconPack: 'feather',
                            icon: 'icon-alert-circle',
                            color: 'danger'
                        })
                    } else {
                        this.$vs.notify({
                            time: 2500,
                            title: 'Error',
                            text: "Server error occured while loading charts. Please try again later.",
                            iconPack: 'feather',
                            icon: 'icon-alert-circle',
                            color: 'danger'
                        })
                    }
                }
            )
        },
        // bar data
        load_bar_data() {

            let url = this.$store.state.apiendpoints.dashboard_stats_view2

            let payload = {
                'metric_type': 'bar_count',
            }

            payload['from_date'] = this.filters.from_date
            payload['to_date'] = this.filters.to_date

            if (this.bar_major_maintenance_sub_type) {
                payload['bar_major_maintenance_sub_type'] = this.bar_major_maintenance_sub_type
            }

            if (this.bar_road_incident_sub_type) {
                payload['bar_road_incident_sub_type'] = this.bar_road_incident_sub_type
            }

            Request(this, 'GET', url, payload).then(
                (res) => {
                    this.bar_labels = res.chart_data.labels || []

                    this.prepare_bar_data(res)

                    let labels_mode = {
                        'routine_maintenance': 'Routine Maintenance',
                        'electrical_maintenance': 'Electrical Maintenance',
                        'major_maintenance': 'Major Maintenance',
                        'corrective_maintenance': 'Corrective Maintenance',
                        'road_incident': 'Road Incident',
                        'enroachment_row': 'Enroachment Row',
                        'safety_program': 'Safety Program',
                    }

                    this.bar_labels_mode = labels_mode
                    this.api_errors = {}
                },
                (err) => {

                    if (err.error) {
                        this.api_errors = err.error
                        this.$vs.notify({
                            time: 2500,
                            title: 'Error',
                            text: (err.error && err.error.__non_field_errors__) ? err.error.__non_field_errors__.join(',') : 'An Error Occured. Please Try Again',
                            iconPack: 'feather',
                            icon: 'icon-alert-circle',
                            color: 'danger'
                        })
                    } else {
                        this.$vs.notify({
                            time: 2500,
                            title: 'Error',
                            text: "Server error occured while loading charts. Please try again later.",
                            iconPack: 'feather',
                            icon: 'icon-alert-circle',
                            color: 'danger'
                        })
                    }
                }
            )
        },
        prepare_bar_data(res) {

            if (this.bar_major_maintenance_sub_type && this.bar_road_incident_sub_type ) {
                let data = {
                    'road_incident': res.chart_data.road_incident || [],
                    'major_maintenance': res.chart_data.major_maintenance || [],
                }
                this.bar_data = data
                
            } else if (this.bar_road_incident_sub_type) {
                let data = {
                    'road_incident': res.chart_data.road_incident || [],
                }
                this.bar_data = data
                
            } else if (this.bar_major_maintenance_sub_type) {
                let data = {
                    'major_maintenance': res.chart_data.major_maintenance || [],
                }
                this.bar_data = data

            } else {
                let data = {
                    'routine_maintenance': res.chart_data.routine_maintenance || [],
                    'electrical_maintenance': res.chart_data.electrical_maintenance || [],
                    'major_maintenance': res.chart_data.major_maintenance || [],
                    'corrective_maintenance': res.chart_data.corrective_maintenance || [],
                    'road_incident': res.chart_data.road_incident || [],
                    'enroachment_row': res.chart_data.enroachment_row || [],
                    'safety_program': res.chart_data.safety_program || [],
                }

                this.bar_data = data
            }
        },
        // line data
        load_line_data() {

            let url = this.$store.state.apiendpoints.dashboard_stats_view2

            let payload = {
                'metric_type': 'line_count',
            }

            if (this.line_filters.line_module_type) {
                payload['line_module_type'] = this.line_filters.line_module_type
            }

            if (this.line_filters.line_major_maintenance_sub_type) {
                payload['line_major_maintenance_sub_type'] = this.line_filters.line_major_maintenance_sub_type
            }

            if (this.line_filters.line_road_incident_sub_type) {
                payload['line_road_incident_sub_type'] = this.line_filters.line_road_incident_sub_type
            }

            Request(this, 'GET', url, payload).then(
                (res) => {
                    this.set_line_chart_background_color(Object.keys(res.chart_data.line_count.dataset))
                    this.line_labels = res.chart_data.line_count.labels
                    this.line_data = res.chart_data.line_count.dataset
                    this.api_errors = {}
                },
                (err) => {
                    if (err.error) {
                        this.api_errors = err.error
                        this.$vs.notify({
                            time: 2500,
                            title: 'Error',
                            text: (err.error && err.error.__non_field_errors__) ? err.error.__non_field_errors__.join(',') : 'An Error Occured. Please Try Again',
                            iconPack: 'feather',
                            icon: 'icon-alert-circle',
                            color: 'danger'
                        })
                    } else {
                        this.$vs.notify({
                            time: 2500,
                            title: 'Error',
                            text: "Server error occured while loading charts. Please try again later.",
                            iconPack: 'feather',
                            icon: 'icon-alert-circle',
                            color: 'danger'
                        })
                    }
                }
            )
        },
        set_line_chart_background_color(years) {
            this.line_chart_background_color[years[0]] = '#E2989F'
            this.line_chart_background_color[years[1]] = '#F0A983'
        }
    }
}
</script>
  
<style lang="scss">
@mixin mobile {
    @media only screen and (max-width: 768px) {
        @content;
    }
}

#dashboard2 {
  
  @include mobile {
    .space-btw-charts {
      margin-bottom: 3vh !important;
    }

    .d2-dropdown-alignment {
      .vs--single .vs__selected {
        max-width: 26vw !important;
      }
    }

    .d2-other-pie-dropdown-alignment {
        .vs--single .vs__selected {
            max-width: 45vw !important;
        } 
    }

    .vs-col {
      padding: 0px !important;
    }

    .widget--heading {
        .input-custom-dropdown .vs__dropdown-toggle {
            background-color: white;
        }
    }

    .mobile-box-count {

        .vx-card {
            border-radius: 1rem;
        }

        .vx-card .vx-card__collapsible-content .vx-card__body {
            padding-top: 1px !important;
            padding-left: 8px !important;
            padding-bottom: 10px !important;
            padding-right: 5px !important;
            min-height: 15vh;
        }

        span {
            font-size: smaller;
        }
    }

    .mobile_to_date {
      .vdp-datepicker__calendar {
        margin-left: -40vw
      }
    }
    
  }
}

.vs--single .vs__selected {
    overflow: hidden !important;
    max-width: 19.8ch !important;
    white-space: nowrap !important;
}

.vs-tabs--ul {
    box-shadow: none;
}

.vs-tabs-primary .line-vs-tabs {
    box-shadow: none !important;
}

.vs-tabs--content {
    padding: 2px 10px !important;
}

.custombox .vs-con-loading__container {
    width: 78% !important;
    margin: 0 auto !important;
}

.widget {
    border-radius: 12px;

    .vx-card__header {
        padding-top: 0;
    }

    &--heading {
        border-top-left-radius: 12px;
        border-top-right-radius: 12px;
        padding: 10px 10px;
        display: flex;
        align-items: center;
        background-color: #CDCDCD;

        h5 {
            display: inline-flex;
            margin: 0;
            flex-grow: 1;
        }

        .right {
            .input-custom-dropdown .vs__dropdown-toggle {
                min-width: 170px;
                background-color: white;
            }
        }
    }
}

.box-data-card {
    width: 19.5% !important;

    .vx-card .vx-card__collapsible-content .vx-card__body {
        padding: 0.8rem !important;
    }
}

.box-data-alignment-d1 {
    display: flex;
    justify-content: center;
    align-items: center;
    min-height: 12vh;

    .box-icon {
        width: 70px;
        height: 65px;
        border-radius: 15px;
        background-color: #FFF7F4;
        color: #FF6B07;
        font-size: 1.8rem;
        font-weight: 600 !important;
        display: flex;
        align-items: center;
        justify-content: center;
    }

    .box-count {
        display: flex;
        flex-direction: column;
        margin-left: 8px;
    }

    .box-count span {
        font-size: 0.8rem;
        font-weight: 600;
        color: #A8B1CA;
    }

    .box-count h6 {
        font-size: 1.5rem;
        margin-top: 5px;
    }
}

.vertical {
    border-left: 3px solid #D9D9D9;
    height: 280px;
}

.d2-dropdown-alignment {
    .vs--single .vs__selected {
        overflow: hidden !important;
        max-width: 12vw!important;
        white-space: nowrap !important;
    }

    .vs__selected-options {
        flex-wrap: nowrap;
    }
}

.d2-other-pie-dropdown-alignment {
    @extend .d2-dropdown-alignment;

    .vs--single .vs__selected {
        max-width: 9vw!important;
    }
}

.space-btw-charts {
    margin-bottom: 5vh;
}

.d2-pie-legend {
    display: flex; 
    justify-content: center; 
    align-items: center; 
    flex-wrap: wrap;

    &--container {
        display: flex; 
        justify-content: center; 
        align-items: center;
        margin-right: 12px;
        margin-bottom: 6px;

        div {
            width: 15px;
            height: 15px;
            border-radius: 4px;
            margin-right: 2px;
        }

        p {
            font-size: 12px;
            font-weight: 600;
        }
    }
}
</style>
<style type="text/css" media="screen, projection">@import url(https://s3.amazonaws.com/assets.freshdesk.com/widget/freshwidget.css);</style>  